var option_webview_default = {
  "option": "cHa-f",
  "user_choice": "RPaHd",
  "check": "Q9h1k",
  "image": "YfJwm",
  "input": "lptAf",
  "title": "-YPoN",
  "centered": "ZD5BY",
  "with_result": "FuRSl",
  "list": "uOZ6X",
  "with_image": "xi5Ip",
  "progress": "rBhOR",
  "progress_value": "cFbrr",
  "label": "WZlh9",
  "cta": "SlKr4",
  "adornment_icon": "_4XJi8",
  "remove": "Apqzb",
  "removeButton": "HDaJZ",
  "removeButtonIcon": "qzFGA",
  "overlay": "Pfzqn",
  "shown": "LbzZ2",
  "dark": "DCNDW",
  "spinner": "W68Ju",
  "spin": "LqUKj",
  "grid": "_6tcr5"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
